import {
  Combobox,
  ComboboxChip,
  ComboboxChips,
  ComboboxChipsInput,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxItem,
  ComboboxList,
  useComboboxAnchor,
} from '@/components/ui/combobox'
import { US_STATES } from '@/lib/usStates'
import type { FieldInputProps } from './fieldInputProps'

const STATE_CODES = US_STATES.map(([code]) => code)
const STATE_NAMES = new Map(US_STATES.map(([code, name]) => [code, name]))

/** Several states as chips, typed to filter by code or name. */
export function StatesField({ field, value, onChange, id, invalid, disabled }: FieldInputProps<string[]>) {
  const anchor = useComboboxAnchor()

  return (
    <Combobox
      multiple
      items={STATE_CODES}
      value={value}
      onValueChange={(next: string[]) => onChange(next)}
      itemToStringLabel={(code: string) => `${code} ${STATE_NAMES.get(code) ?? ''}`}
      disabled={disabled}
    >
      <ComboboxChips ref={anchor}>
        {value.map((code) => (
          <ComboboxChip key={code} removeLabel={`Remove ${STATE_NAMES.get(code) ?? code}`}>
            {code}
          </ComboboxChip>
        ))}
        <ComboboxChipsInput
          id={id}
          aria-label={field.label}
          aria-invalid={invalid || undefined}
          placeholder={value.length === 0 ? field.placeholder || 'Pick states' : undefined}
        />
      </ComboboxChips>
      <ComboboxContent anchor={anchor}>
        <ComboboxEmpty>No matches</ComboboxEmpty>
        <ComboboxList>
          {(code: string) => (
            <ComboboxItem key={code} value={code}>
              {STATE_NAMES.get(code)} ({code})
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  )
}
